module.exports = __webpack_public_path__ + "img/1212b_2.56e2730e.jpg";